import { GridProps } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';
import { ListingProps } from '@/types/listing';
import Section, { sectionPadding } from '@/components/frontend/FullSection';
import ForestInformationBlock from './Block';

const ForestInformationSection = ({
  listing,
  forestData,
  ...gridStyles
}: ListingProps & GridProps) => {
  const { t } = useTranslation('frontoffice');
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <Section
      ref={sectionRef}
      backgroundImage="url('/forest-info-bg.jpg')"
      backgroundSize="cover"
      backgroundPosition="0% 0%"
      as="div"
      py={sectionPadding}
      title={t('forest_information', 'Metsävaratiedot')}
      {...gridStyles}
    >
      <ForestInformationBlock
        listing={listing}
        forestData={forestData}
        sectionRef={sectionRef}
      />
    </Section>
  );
};

export default ForestInformationSection;
